var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Subject, BehaviorSubject } from 'rxjs';
import { AuthService } from './auth.service';
import { get } from 'lodash';
import * as i0 from "@angular/core";
import * as i1 from "./auth.service";
var HeaderService = /** @class */ (function () {
    function HeaderService(authService) {
        this.authService = authService;
        this.iconSet = new Subject();
        this.panelOpen = new Subject();
        this.panelClose = new Subject();
        this.titleSet = new Subject();
        this.tabTitleSet = new Subject();
        this.displayHeader = new Subject();
        this.quickBack = new Subject();
        this.breadcrumbsListener = new BehaviorSubject({});
        this.displaySubHeader = new BehaviorSubject({
            display: false,
            close: false,
            message: '',
            userType: 'reviewer',
            bannerType: 'trial'
        });
    }
    Object.defineProperty(HeaderService.prototype, "showSubheader", {
        get: function () {
            var display = localStorage.getItem('eyrus-show-subheader');
            var show = (display === 'true' || display === null) ? true : false;
            return show;
        },
        set: function (value) {
            localStorage.setItem('eyrus-show-subheader', value.toString());
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Emit icon name to header component
     * @param options Name of current icon
     */
    HeaderService.prototype.setIcon = function (options) {
        this.iconSet.next(options);
    };
    /**
     * Notify to side panel that should be opened
     */
    HeaderService.prototype.openSidePanel = function () {
        this.panelOpen.next();
    };
    /**
     * Notify to side panel that should be closed
     */
    HeaderService.prototype.closeSidePanel = function () {
        this.panelClose.next();
    };
    /**
     * Notify to header component that a title should be replaced
     * @param title new title
     */
    HeaderService.prototype.setTitle = function (title) {
        this.titleSet.next(title);
    };
    /**
     * Notify to display or hide header
     * @param display boolean
     */
    HeaderService.prototype.setDisplay = function (display) {
        this.displayHeader.next(display);
    };
    HeaderService.prototype.checkSubBanner = function () {
        var _this = this;
        var currentUser = get(this.authService, 'user') || {};
        var account = currentUser.accounts.find(function (e) {
            return e.accountId.toString() === _this.authService.accountId.toString();
        });
        if (!account)
            return;
        var options = __assign({ 
            // display: account.isTrialing && this.showSubheader,
            account: account }, this.getSubheaderOptions(account));
        this.displaySubHeader.next(options);
    };
    HeaderService.prototype.getSubheaderOptions = function (account) {
        var userType = account.assignedContractTypes.indexOf('reviewer') !== -1 ? 'reviewer'
            : account.assignedContractTypes.indexOf('admin') !== -1 ? 'admin' : 'submitter';
        var bannerType = account.lockoutDateTimeUtc ? 'locked' : 'trial';
        var display = (account.isTrialing && this.showSubheader) || (bannerType === 'locked');
        // const close = bannerType === 'trial' ? true : false;
        var close = true;
        return { close: close, userType: userType, bannerType: bannerType, display: display };
    };
    HeaderService.ngInjectableDef = i0.defineInjectable({ factory: function HeaderService_Factory() { return new HeaderService(i0.inject(i1.AuthService)); }, token: HeaderService, providedIn: "root" });
    return HeaderService;
}());
export { HeaderService };
